<template>
  <div class="empty-content">
    <div class="empty-content__content">
      <slot name="icon"></slot>
      <span>{{ text }}</span>
    </div>
    <slot name="action"></slot>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  text: string
}>()
</script>

<style lang="scss">
@import './empty-content.scss';
</style>
